import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {
          height: '184px',
          overflow: 'hidden',
        } }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = { style: { display: 'flex', alignItems: 'center', color: '#1D2129' } }

import { IconShareInternal } from "@arco-design/web-vue/es/icon";
import API from "@/api";
import { ref } from "vue";
import { useRouter } from "vue-router";

interface Props {
  app: API.AppVO;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppCard',
  props: {
    app: { default: () => {
    return {};
  } }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const doCardClick = () => {
  router.push(`/app/detail/${props.app.id}`);
};

// 分享弹窗的引用
const shareModalRef = ref();

// 分享链接
const shareLink = `${window.location.protocol}//${window.location.host}/app/detail/${props.app.id}`;

// 分享
const doShare = (e: Event) => {
  if (shareModalRef.value) {
    shareModalRef.value.openModal();
  }
  // 阻止冒泡，防止跳转到详情页
  e.stopPropagation();
};

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_card_meta = _resolveComponent("a-card-meta")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_ShareModal = _resolveComponent("ShareModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      class: "appCard",
      hoverable: "",
      onClick: doCardClick
    }, {
      actions: _withCtx(() => [
        _createElementVNode("span", {
          class: "icon-hover",
          onClick: doShare
        }, [
          _createVNode(_unref(IconShareInternal))
        ])
      ]),
      cover: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            style: { width: '100%', height: '100%' },
            alt: __props.app.appName,
            src: __props.app.appIcon
          }, null, 8, _hoisted_2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_card_meta, {
          title: __props.app.appName,
          description: __props.app.appDesc
        }, {
          avatar: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_avatar, {
                size: 24,
                "image-url": __props.app.user?.userAvatar,
                style: { marginRight: '8px' }
              }, null, 8, ["image-url"]),
              _createVNode(_component_a_typography_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.app.user?.userName ?? "无名"), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["title", "description"])
      ]),
      _: 1
    }),
    _createVNode(_component_ShareModal, {
      link: shareLink,
      title: "应用分享",
      ref_key: "shareModalRef",
      ref: shareModalRef
    }, null, 512)
  ], 64))
}
}

})